import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

// allTeacher/allTeacherMeta/singleTeacher/createTeacher are the BaseResolver('Teacher', Teacher)
// CRUD ops. Tenant and `type: teacher` are enforced server-side (TeacherRepository.filterWithTenant),
// so the client filter carries neither — that duplicated predicate is exactly what the retired
// teacherFilter.ts used to paper over.
//
// Separate fragment fields from the Users list's (view/settings/organization/users/graphql.ts) —
// that one omits `createdAt`, which this Joined column needs. `type` stays in this fragment
// because the teacher detail's Summary tab renders it (item/tabs/SummaryTab.tsx). `tenantId`
// is dropped from the selection because nothing under view/teachers renders it. `company` is
// selected here — not just for the detail screen — because `buildGraphqlQuery` feeds both
// `allTeacher` and `singleTeacher` off this one fragment. `company.type` lets SummaryTab.tsx
// tell a school membership from a teacher's own domain-derived company (CompanyRepositoryMiddleware
// assigns every user a company; only a `type: school` one is a school).
const teacherDefaultFragment = gql`
  fragment teacherDefaultFragment on Teacher {
    _id
    status
    type
    createdAt
    phone
    profile {
      _id
      name
      email
      picture
    }
    roles
    company {
      _id
      name
      code
      type
    }
  }
`
export const teacherQueries = buildGraphqlQuery('Teacher', teacherDefaultFragment)
